import { Grid, Typography } from "@mui/material";
import {JSX} from "react";

interface ContentProps {
    firstContent: string | JSX.Element;
    lastContent: JSX.Element;
    xs?: number;
    lastContentAlign?: "left" | "right";
}

export default function DetailsContent({firstContent, lastContent, xs, lastContentAlign}: ContentProps){
    return (
        <>
            <Grid size={xs ? xs : 6}>{firstContent}</Grid>
            <Grid
                size={xs ? xs : 6}
                sx={{
                    textAlign: lastContentAlign ? lastContentAlign : "right"
                }}>{lastContent}</Grid>
        </>
    );
}

export const title = (text: string) => (<Typography variant="body2">{text}</Typography>)
export const contentText = (text: string) => (<Typography variant="body2" sx={{
    color: "info.main"
}}>{text}</Typography>)
export const contentNotSet = <Typography variant="body2" sx={{
    color: "text.disabled"
}}>-</Typography>